import React, { useEffect, useState } from "react";
import { SettingsProfilePanel } from "./settings-profile-panel";
import { SettingsStorePanel } from "./settings-store-panel";
import { SettingsWalletPanel } from "./settings-wallet-panel";
import { SettingsNotificationsPanel } from "./settings-notifications-panel";
import { SettingsSecurityPanel } from "./settings-security-panel";
import { SettingsTabs } from "./settings-tabs";
import { FiUser } from "react-icons/fi";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";
import { CiBank } from "react-icons/ci";
import { PiBellSimple } from "react-icons/pi";
import { SlLock } from "react-icons/sl";
import Loader from "../../../../Components/Common/Loader";
import { useQuery } from "@apollo/client";
import { GET_PROFILE } from "../../../../Utils/Queries";
import { getProfileFromQuery } from "../../../utils/get-profile";

const SETTINGS_TABS = [
  
  {
    key: "store",
    label: "Store",
    icon: <HiOutlineBuildingStorefront />,
    render: (profile) => <SettingsStorePanel profile={profile} />,
  },
  {
    key: "profile",
    label: "Profile",
    icon: <FiUser />,
    render: (profile) => <SettingsProfilePanel profile={profile} />,
  },
  {
    key: "wallet",
    label: "Banks & Payouts",
    icon: <CiBank />,
    render: () => <SettingsWalletPanel />,
  },
  // {
  //   key: "notifications",
  //   label: "Notifications",
  //   icon: <PiBellSimple />,
  //   render: () => <SettingsNotificationsPanel />,
  // },
  // {
  //   key: "security",
  //   label: "Security",
  //   icon: <SlLock />,
  //   render: () => <SettingsSecurityPanel />,
  // },
];

export default function SellerSettingsPage() {
  const [tab, setTab] = useState(0);

  const { data: profileData, loading: profile_loading } = useQuery(GET_PROFILE, {
    fetchPolicy: "cache-and-network",
  });
  const user_profile = getProfileFromQuery(profileData) ?? {};

  useEffect(() => {
    setTab((current) =>
      current >= SETTINGS_TABS.length ? SETTINGS_TABS.length - 1 : current,
    );
  }, [SETTINGS_TABS.length]);

  const activeTab = SETTINGS_TABS[tab] ?? SETTINGS_TABS[0];

  return (
    <div className="min-w-0 pb-16 pt-2 sm:pt-4 md:pt-6">
      {profile_loading && <Loader />}

      <header className="mb-5 md:mb-8 lg:mb-10">
        <h1 className="my-0 text-[20px] font-semibold tracking-tight text-[#151515] sm:text-[22px] md:text-[24px]">
          Settings
        </h1>
        <p className="my-0 mt-1 max-w-2xl text-[12px] leading-relaxed text-[#6B7280] sm:mt-1.5 sm:text-[13px]">
          Manage your account, store and preferences
        </p>
      </header>

      <div className="flex min-w-0 flex-col gap-6 lg:flex-row lg:items-start lg:gap-10">
        <SettingsTabs tabs={SETTINGS_TABS} value={tab} onChange={setTab} />

        <div
          className="min-w-0 flex-1 pb-4"
          role="tabpanel"
          id={`settings-panel-${activeTab.key}`}
          aria-labelledby={`settings-tab-${activeTab.key}`}
        >
          {activeTab.render(user_profile)}
        </div>
      </div>
    </div>
  );
}
